// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.customAccordion_container .card-header {
    border-bottom: 1px solid #FFF;
    background: #FFF;
    padding: 8px 8px;
}

.customAccordion_container .card-header span:first-child {
    font-size: 18px;
    font-weight: bold;
    width: 20px;
    text-align: center;
}

#accordion_body{
    padding-top: 0px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Accordion/Accordion.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".customAccordion_container .card-header {\n    border-bottom: 1px solid #FFF;\n    background: #FFF;\n    padding: 8px 8px;\n}\n\n.customAccordion_container .card-header span:first-child {\n    font-size: 18px;\n    font-weight: bold;\n    width: 20px;\n    text-align: center;\n}\n\n#accordion_body{\n    padding-top: 0px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
